module.exports = __webpack_public_path__ + "img/comment-dots-regular.11218bb3.svg";